export default __webpack_public_path__ + "static/media/icon-notification.6121268f.svg";